import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';

import { Observable, Subject, takeUntil } from 'rxjs';
import { CardContent } from 'src/app/types/card-content';
import { NewsService } from '../../services/news.service';

/**
 * news component
 * which shows latest three news from rss feed on login screen
 * @class NewsComponent
 * @typedef {NewsComponent}
 * @implements {OnInit}
 */
@Component( {
    selector: 'riege-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    standalone: false
} )
export class NewsComponent implements OnInit, OnDestroy {
    @Input( { required: true } ) count = 0;
    @Input( { required: true } ) feed = '';

    @Output() hasPosts = new EventEmitter<boolean>();

    /**  lifecycle hook */
    readonly #destroyed: Subject<void> = new Subject<void>();

    #newsService = inject( NewsService );

    /** reference on list of rss feed news */
    newsItems$!: Observable<CardContent[]>;

    /** on init get list of news from rss feed */
    ngOnInit(): void {
        this.getNews();
    }

    getNews() {
        this.#newsService
            .getRSSNews( this.feed, this.count )
            .pipe( ( data ) => ( this.newsItems$ = data ), takeUntil( this.#destroyed ) )
            .subscribe( ( data ) => this.hasPosts.emit( data.length > 0 ) );
    }

    ngOnDestroy(): void {
        this.#destroyed.next();
        this.#destroyed.complete();
    }
}
